import { Component } from "react";

import MultiFactorAuthStatusDisplay, {
    type IMultiFactorAuthStatusDisplayProps,
} from "commonComponents/utilities/MultiFactorAuthStatusDisplay/MultiFactorAuthStatusDisplay";

export default class MultiFactorAuthRoleStatus extends Component<IMultiFactorAuthStatusDisplayProps> {
    private getAdditionalInfo = () => {
        const { isMfaEnabled } = this.props;
        const additionalInfo: string = isMfaEnabled
            ? "For your security, this role requires the User to multi-factor authenticate upon login."
            : "This role does not require the User to multi-factor authenticate upon login.";
        return additionalInfo;
    };

    render() {
        const { isMfaEnabled } = this.props;
        return (
            <MultiFactorAuthStatusDisplay
                isMfaEnabled={isMfaEnabled}
                className="padding-bottom-md"
                renderAdditionalInfo={this.getAdditionalInfo}
            />
        );
    }
}
